import React from 'react';
import { safeHTML } from '../../../utils/safeHTML';
import { image } from '../../../utils/data/baseUrl';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import useStateControls from '../../../hooks/useStateControls';

const NyTaskWinners = React.forwardRef(function NyTaskWinners(
  { description, subDescription, img, button, list, callbacks, title },
  ref,
) {
  const { setState } = useStateControls();

  const onClick = () => {
    setState('nyRating');
    callbacks.setActiveWinners({ title, list });
  };

  return (
    <div className={`ny-task__winners`}>
      <img className={'ny-task__winners-image'} src={img} alt={'winners-img'} />
      <h3 className={'ny-task__winners-title'}>{safeHTML(description)}</h3>
      <div className={'ny-task__winners-text'}>{safeHTML(subDescription)}</div>
      {!!list?.length && <CustomButton {...button} onClick={onClick} />}
    </div>
  );
});
export default NyTaskWinners;
NyTaskWinners.propTypes = {};
